import { useMutation } from '@tanstack/react-query';
import { registerAdmin } from '../../../admin/Services/AdminUserService';

export const useRegisterAdmin = (onSuccess) => {
  const { mutate, isPending } = useMutation({
    mutationFn: registerAdmin,
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
